interface GTMDataLayerEvent {
    event: string;
    ndl_loging_status: boolean;
    ndl_p_uid: string;
    ndl_c_uid: string | null;
    ndl_email: string;
    ndl_trial: boolean;
    ndl_customer: boolean | null;
    ndl_tsid: string | null;
    ndl_multicompany: boolean;
}

declare global {
    interface Window {
        dataLayer: unknown[];
        gtmData?: GTMDataLayerEvent;
    }
}

export async function initGtm() {
    try {
        const response = await fetch("/gtm/datalayer", {
            credentials: "include"
        });

        if (!response.ok) {
            throw new Error(
                `Unable to load GTM data layer (${response.status})`
            );
        }

        const payload: GTMDataLayerEvent =
            await response.json();

        window.gtmData = payload;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    }
    catch (error) {
        console.error("Error initializing GTM", error);
    }
}